import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import {
  Button, Col, Form, FormControl, FormLabel, InputGroup, Spinner,
} from 'react-bootstrap';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import { Link, useNavigate } from 'react-router-dom';
import SweetAlert from 'react-bootstrap-sweetalert';
import useAuth from '../hooks/useAuth';
import useForm from '../hooks/useForm';

import './auth.css';

function ForgotPassword() {
  const title = 'Forgot Password';
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [catchError, setIsCatchError] = useState('');
  const [isAlert, setIsAlert] = useState(false);
  const [isError, setIsError] = useState(false);

  const { forgotPassword } = useAuth();

  const handleForgot = async (e, data) => {
    try {
      setIsLoading(true);
      await forgotPassword(data);
      setIsAlert(true);
      setIsLoading(false);
    } catch (err) {
      setIsCatchError(err.message);
      setIsError(true);
      setIsLoading(false);
    }
  };

  const validators = {
    memberID: {
      required: {
        value: true,
        message: 'Member ID is required',
      },
    },
  };

  const onForgot = () => {
    setIsAlert(false);
    navigate('/verify-forgot-password');
  };

  const onConfirm = () => {
    setIsAlert(false);
    setIsError(false);
  };

  const {
    handleChange,
    handleSubmit,
    errors,
  } = useForm({
    onSubmit: handleForgot,
    validators,
  });

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <main className="container">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/">Home</Link></Breadcrumb.Item>
          <Breadcrumb.Item><Link to="/login">Login</Link></Breadcrumb.Item>
          <Breadcrumb.Item active>{title}</Breadcrumb.Item>
        </Breadcrumb>
        <h1 className="page-title">{title}</h1>
        <div className="container-auth">
          <Form className="row g-2" noValidate>
            <Form.Group as={Col} lg="12" className="form-input" controlId="inputMemberID">
              <FormLabel>NSSF Member No</FormLabel>
              <FormControl type="number"
                           className="form-control form-input-top"
                           isInvalid={errors?.memberID}
                           placeholder="45XXXXXX"
                           onChange={handleChange('memberID')}
              />
              <Form.Control.Feedback type="invalid">Member Id is required</Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} md="12" controlId="inputPhoneNumber">
              <Form.Label>Phone Number</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text id="inputGroupPrepend">+255</InputGroup.Text>
                <Form.Control type="number"
                              isInvalid={ errors.phonenumber }
                              placeholder="756140140"
                              aria-describedby="inputGroupPrepend"
                              onChange={handleChange('phoneNumber')}
                />
                <Form.Control.Feedback type="invalid">
                  { errors.phonenumber && 'Phone Number is required' }
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            <Button className="w-100 btn btn-green mt-3"
                    type="button"
                    disabled={isLoading}
                    onClick={handleSubmit}
            >
              <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" hidden={!isLoading}/>
              <span className="px-2">Reset Password</span>
            </Button>
            <p>
              <div className="row mb-3"/>
              <div className="mt-4">
                <span className="helper-text m-b-10">
                    Already have an Account? <i className="fa fa-lock"/>
                    <Link to="/login">Back to Login</Link></span><br/>
                <span className="helper-text m-b-10">
                        Did not receive SMS / Email?
                        <i className="fa fa-envelope"/> <Link
                  to="/reverify">Resend</Link></span><br/>
                <span className="helper-text m-b-10">
                        Don't have an account? <i className="fa fa-user-plus"/>
                        <Link to="/signup">Register</Link></span>
              </div>
            </p>
          </Form>
        </div>
      </main>
      {isAlert
      && <SweetAlert
        success
        title="Successfully Sent!"
        onConfirm={onForgot}
      >
        Verification code is sent to your phone and email
      </SweetAlert>
      }
      {isError
      && <SweetAlert
        danger
        title= {catchError}
        onConfirm={onConfirm}
        timeout={10000}
      >
      </SweetAlert>}
    </>
  );
}

export default ForgotPassword;
